import React from "react";
import { ReactComponent as QldSvg } from "./qld.svg";

export const QLD: React.FC<{}> = () => {
    return <QldSvg />;
};
